import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import LuxuryChalets from './components/LuxuryChalets';
import ChaletGallery from './components/ChaletGallery';
import ExploreSkiTrikke from './components/ExploreSkiTrikke';
import SkiTrikkeRentals from './components/SkiTrikkeRentals';
import Contact from './components/Contact';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero scrolled={scrolled} />
      <About />
      <LuxuryChalets />
      <ChaletGallery />
      <ExploreSkiTrikke />
      <SkiTrikkeRentals />
      <CTASection />
      <Contact />
      <Footer />
    </div>
  );
}
